import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={25.532}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 49683 49357"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path d="m34285 17601-1451 52-3 21131 1412-2z" className="fil0" />
      <path
        d="m34703 45406 6374-52c1 1961 435 1628-3188 1628-607 1-1929 79-2447 11-999-131-744-502-739-1587zm-26106-2 6379-51c-9 1963 460 1627-3191 1630-2389 1-3186 693-3188-1579zm-5786-2625c-781-1526-334-15410-334-18461 0-3063-98-6282-12-9323 57-2014 1150-1559 3047-1555 6439 17 39808-411 41518 279 543 1919 217 11796 217 14646 0 1761 397 13748-455 14361-665 327-42012 558-43981 53zm-2579-248c275 1188 997 2164 2125 2560 1161 410 2622 128 3918 283-18 4252 1610 3932 5510 3932 3726 0 5566 312 5562-3868 1002-276 13523-244 15032-63-14 2142 113 3302 2069 3824 713 210 5259 171 6287 107 2932-183 2549-2598 2742-3932 2664-369 4527 386 5704-1872 684-1311 395-5279 395-7042V21282c0-7047 1275-10241-5009-10220l-38042 3c-2600-1-4738-267-5913 1673-860 1421-460 12307-460 14818 0 2954-389 12854 80 14975z"
        className="fil0"
      />
      <path
        d="M7749 38837h1605l5-21297-1671-1zM14028 38838l1599-1V17543l-1666-4zM20299 38845l1552-47 1-21218-1621-40zM26574 17658l50 21090 1420 8-4-21037zM40114 29529c2048-1191 3325 2134 1495 2980-1871 865-3591-1761-1495-2980zm-2560 2074c707 4199 7250 3347 6610-1198-240-1702-2001-3075-4042-2682-1568 303-2905 1872-2568 3880zM40063 19790c2033-1198 3520 2066 1521 2979-1988 908-3467-1834-1521-2979zm130-1782c-4554 1133-2886 7457 1513 6502 1635-355 2900-2143 2379-4161-375-1456-1986-2815-3892-2341zM32173 8484c1288-3204-678-4249-58-7917L30567 0c-1111 4897 1277 5285 136 7674 386 361 886 649 1470 810zM11363 8510c1329-3705-821-4249-19-7947L9774 8c-1013 3778 834 4518 167 7770l1422 732zM18285 8510c581-1288 645-2298 213-3860-636-2303-332-1977-302-4147L16706 73c-1079 3734 1031 4935 144 7724l1435 713zM25141 8459c874-985 638-2570 275-3844-512-1790-599-2015-234-4037L23633 10c-923 3794 967 5112 124 7768l1384 681zM34285 17601l-42 21181-1412 2 3-21131 1451-52zm0 0c-51-24 125-75-451-154l-1200 95 41 21297c785 217 940 228 1718-9 36-343 288-18786 39-20783-49-393-136-424-147-446z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
